import * as yup from 'yup';
import { passwordValidator } from '../../../(utils)/passwordValidator';

const validationSchema = yup.object({
  email: yup.string().email().required(),
  password: passwordValidator,
});

export { validationSchema };
